import React from 'react'

interface Props {
    file: any;
    idx: number;
    folders: any[];
    onSelectFolder: (file: any, folderId: string) => void;
    createFolder: (file: any, folderId: string) => void;
    fileTitleTypes: any[];
    onSelectType: (file: any, typeId: string) => void;
    createType: (file: any, typeId: string) => void;
}


const FoldersAndSubjects:React.FC<Props> = ({
    file,
    idx,
    folders,
    onSelectFolder,
    createFolder,
    fileTitleTypes,
    onSelectType,
    createType
}: Props) => {


    const [creatingFolder, setCreatingFolder] = React.useState<boolean>(false);
    const [newFolderName, setNewFolderName] = React.useState<string>('');
    const [creatingTitle, setCreatingTitle] = React.useState<boolean>(false);
    const [newTitleTypeName, setNewTitleTypeName] = React.useState<string>('');
    return (
        <>

            <td>
                <select
                    value={file.folderId || ''}
                    onChange={(e) => {
                        if (e.target.value === `__new__${idx}`) {
                            setCreatingFolder(true);
                        } else onSelectFolder(file, e.target.value);
                    }}
                    disabled={file.uploaded}
                >
                    <option value="">
                        בחר תיקייה
                    </option>
                    {folders.map((folder) => (
                        <option key={folder.id} value={folder.id}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p>{folder.name}</p>
                                {/* <Tooltip title="מחיקה">
                                                 <DeleteOutlined style={{
                                                    fontSize: '18px',
                                                    color: '#186cc7'0
                                                }} onClick={() => deleteFolder(folder.id)} /></Tooltip> */}

                            </div>
                        </option>
                    ))}
                    <option value={`__new__${idx}`}>+ יצירת תיקייה חדשה</option>
                </select>
                {creatingFolder && (
                    <div className="udp-new-folder">
                        <input
                            type="text"
                            placeholder="שם תיקייה חדשה"
                            value={newFolderName}
                            onChange={(e) => setNewFolderName(e.target.value)}
                            onBlur={ async () => {
                                await createFolder(file, newFolderName)
                                setCreatingFolder(false);
                                setNewFolderName('');
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    createFolder(file, newFolderName);
                                    setCreatingFolder(false);
                                    setNewFolderName('');
                                }
                            }}
                        />
                    </div>
                )}
            </td>

            <td>
                <select
                    value={file.documentTypeId || ''}

                    onChange={(e) => {
                        if (e.target.value === `__new__${idx}`) {
                            setCreatingTitle(true);
                        } else { onSelectType(file, e.target.value); }
                    }}
                    disabled={file.uploaded}
                >
                    <option value="" >
                        בחר נושא
                    </option>
                    {fileTitleTypes.map((t: any) => (
                        <option key={t.id} value={t.id}>
                            {t.name}
                        </option>
                    ))}
                    <option value={`__new__${idx}`}>+ יצירת נושא חדש</option>
                </select>
                {creatingTitle && (
                    <div className="udp-new-folder">
                        <input
                            type="text"
                            placeholder="שם נושא חדש"
                            value={newTitleTypeName}
                            onChange={(e) => setNewTitleTypeName(e.target.value)}
                            onBlur={async() => {
                                await createType(file, newTitleTypeName)
                                setCreatingTitle(false);
                                setNewTitleTypeName('');
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    createType(file, newTitleTypeName);
                                    setCreatingTitle(false);
                                    setNewTitleTypeName('');
                                }
                            }}
                        />
                    </div>
                )}
            </td>



        </>
    )
}

export default FoldersAndSubjects